var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _g, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeActionResponse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 100,
    viewBox: "0 0 140 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.7167 79.185L87.2834 60.0309L105.859 68.1965L86.2803 90L67.7167 79.185Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2473 39.3802L56.8928 46.6501L40.4504 58.3096L27.2853 50.1809L43.2473 39.3802Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8582 71.2427L84.7151 47.4326L108.313 57.5832L83.4408 84.6866L59.8582 71.2427Z",
    fill: "url(#paint0_linear_722_15901)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2563 60.0711L80.7314 58.942L83.421 56.1465L85.9459 57.2718L83.2563 60.0711Z",
    fill: "url(#paint1_linear_722_15901)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8657 70.9937L74.7323 63.0112C74.4108 62.8505 74.3442 62.5172 74.5872 62.2703C74.8304 62.0232 75.293 61.9487 75.6145 62.1095L91.7479 70.0919C92.0694 70.2526 92.136 70.5859 91.893 70.8329C91.6499 71.0838 91.1873 71.1544 90.8657 70.9937Z",
    fill: "#D8D8D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6513 73.0698L72.5179 65.0875C72.1963 64.9267 72.1297 64.5935 72.3728 64.3464C72.6159 64.0995 73.0786 64.025 73.4 64.1857L89.5334 72.1681C89.8549 72.3289 89.9215 72.6621 89.6785 72.9092C89.4354 73.1561 88.9728 73.2306 88.6513 73.0698Z",
    fill: "#D8D8D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6007 75.164L70.4673 67.1816C70.1459 67.0209 70.0792 66.6876 70.3222 66.4406C70.5654 66.1935 71.028 66.1191 71.3494 66.2798L87.4829 74.2623C87.8044 74.423 87.8711 74.7563 87.6279 75.0032C87.3849 75.2542 86.9222 75.3248 86.6007 75.164Z",
    fill: "#D8D8D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5469 77.2626L68.4135 69.2802C68.0919 69.1195 68.0254 68.7861 68.2684 68.5392C68.5114 68.2921 68.9741 68.2177 69.2956 68.3784L85.429 76.3609C85.7506 76.5216 85.8172 76.8549 85.5741 77.1018C85.3311 77.3489 84.8684 77.4234 84.5469 77.2626Z",
    fill: "#D8D8D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7279 61.0014L83.5943 53.0189C83.2729 52.8581 83.2062 52.5249 83.4494 52.2779C83.6924 52.0309 84.155 51.9564 84.4765 52.1172L100.61 60.0996C100.931 60.2603 100.998 60.5936 100.755 60.8406C100.512 61.0915 100.049 61.162 99.7279 61.0014Z",
    fill: "#D8D8D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5133 63.0798L81.3797 55.0974C81.0583 54.9366 80.9916 54.6034 81.2348 54.3563C81.4778 54.1094 81.9404 54.0349 82.2619 54.1957L98.3954 62.178C98.7168 62.3388 98.7835 62.672 98.5404 62.9191C98.2973 63.166 97.8347 63.2405 97.5133 63.0798Z",
    fill: "#D8D8D8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4628 65.1739L79.3293 57.1915C79.0079 57.0307 78.9412 56.6975 79.1843 56.4505C79.4274 56.2035 79.89 56.129 80.2116 56.2897L96.345 64.2722C96.6664 64.4329 96.7331 64.7662 96.4901 65.0132C96.2469 65.2641 95.7843 65.3346 95.4628 65.1739Z",
    fill: "#D8D8D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4085 67.2703L77.2751 59.2878C76.9535 59.1272 76.8869 58.7938 77.13 58.5469C77.373 58.2999 77.8356 58.2254 78.1572 58.3861L94.2906 66.3685C94.6121 66.5293 94.6787 66.8625 94.4357 67.1095C94.1926 67.3566 93.73 67.4311 93.4085 67.2703Z",
    fill: "#D8D8D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8038 33.9337L55.1691 41.7318L37.8595 54.2387L24 45.5192L40.8038 33.9337Z",
    fill: "url(#paint2_linear_722_15901)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7055 47.524L33.492 42.4741C33.3077 42.3722 33.292 42.2036 33.4607 42.0939C33.6253 41.984 33.9115 41.9802 34.0957 42.0821L43.3092 47.1319C43.4936 47.2339 43.5093 47.4024 43.3406 47.5122C43.1759 47.622 42.8898 47.6259 42.7055 47.524Z",
    fill: "#D8D8D8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3019 48.438L32.0884 43.3882C31.9041 43.2863 31.8885 43.1177 32.057 43.0079C32.2217 42.8982 32.5079 42.8942 32.6921 42.9962L41.9057 48.046C42.0899 48.1479 42.1056 48.3165 41.9371 48.4262C41.7724 48.5322 41.4861 48.54 41.3019 48.438Z",
    fill: "#D8D8D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8983 49.3499L30.6848 44.3001C30.5006 44.1981 30.4849 44.0296 30.6535 43.9198C30.8181 43.81 31.1044 43.8061 31.2886 43.908L40.5021 48.9579C40.6864 49.0598 40.702 49.2284 40.5335 49.3381C40.3688 49.4439 40.0827 49.4479 39.8983 49.3499Z",
    fill: "#D8D8D8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4949 50.2595L29.2815 45.2097C29.0971 45.1078 29.0814 44.9391 29.2501 44.8294C29.4148 44.7197 29.7009 44.7157 29.8852 44.8176L39.0987 49.8674C39.283 49.9694 39.2987 50.1379 39.13 50.2477C38.9654 50.3575 38.6792 50.3614 38.4949 50.2595Z",
    fill: "#D8D8D8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3116 42.748L40.0981 37.6982C39.9138 37.5962 39.8981 37.4277 40.0667 37.3178C40.2313 37.2081 40.5176 37.2042 40.7018 37.3061L49.9153 42.3558C50.0996 42.4578 50.1154 42.6265 49.9467 42.7362C49.782 42.842 49.4958 42.8498 49.3116 42.748Z",
    fill: "#D8D8D8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9082 43.662L38.6947 38.6122C38.5105 38.5102 38.4948 38.3417 38.6633 38.232C38.828 38.1221 39.1142 38.1182 39.2985 38.2202L48.512 43.27C48.6963 43.3718 48.7119 43.5405 48.5434 43.6502C48.3826 43.7561 48.0925 43.764 47.9082 43.662Z",
    fill: "#D8D8D8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.508 44.5716L37.2946 39.5218C37.1103 39.42 37.0946 39.2513 37.2632 39.1415C37.4279 39.0318 37.714 39.0278 37.8984 39.1298L47.1119 44.1796C47.2961 44.2815 47.3118 44.4501 47.1432 44.5598C46.9786 44.6697 46.6923 44.6736 46.508 44.5716Z",
    fill: "#D8D8D8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1046 45.4857L35.8911 40.436C35.7069 40.334 35.6912 40.1655 35.8598 40.0556C36.0244 39.9459 36.3107 39.942 36.4949 40.0438L45.7084 45.0936C45.8927 45.1956 45.9083 45.3641 45.7398 45.474C45.5751 45.5798 45.2889 45.5876 45.1046 45.4857Z",
    fill: "#D8D8D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7175 10.0778L99.2331 17.9739C100.123 18.2484 100.656 19.158 100.464 20.0676L94.3009 49.1782L93.1442 49.5743L66.876 37.1106L71.518 11.4147C71.6983 10.3993 72.7295 9.77195 73.7175 10.0778Z",
    fill: "url(#paint3_linear_722_15901)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1382 39.0204L48.2561 50.3589C47.6406 50.798 48.1189 52.9151 48.7698 53.2994L73.5364 67.9469C74.5284 68.5311 75.7868 68.3821 76.6101 67.5783L93.5631 51.0843L93.3004 49.7394L66.1382 39.0204Z",
    fill: "url(#paint4_linear_722_15901)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2896 44.9977C67.9112 44.826 67.4693 44.8729 67.1354 45.1202L50.4922 57.4494C49.8858 57.8956 49.9283 58.8396 50.5694 59.2299L74.9634 74.1108C75.9404 74.7043 77.18 74.5529 77.991 73.7364L93.5248 58.1475C94.0882 57.582 93.9141 56.6278 93.1871 56.2979L68.2896 44.9977Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1382 38.8752L48.2561 50.2136C47.6406 50.6528 48.1189 52.7699 48.7698 53.1541L73.5364 67.8016C74.5284 68.3857 75.7868 68.2368 76.6101 67.433L93.5631 50.9389L93.3004 49.5942L66.1382 38.8752Z",
    fill: "url(#paint5_linear_722_15901)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5612 10.4733L98.0768 18.3695C98.9667 18.6439 99.4999 19.5535 99.3078 20.463L93.1446 49.5738L65.7197 37.5062L70.3578 11.8142C70.5382 10.7948 71.5733 10.1675 72.5612 10.4733Z",
    fill: "url(#paint6_linear_722_15901)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6415 37.0158L71.166 11.959C71.2443 11.5317 71.6129 11.218 72.0481 11.218C72.1382 11.218 72.2284 11.2337 72.3147 11.2572L97.8301 19.1534C98.3163 19.3024 98.6025 19.7925 98.4967 20.2904L92.5413 48.4092L66.6415 37.0158Z",
    fill: "url(#paint7_linear_722_15901)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8757 37.5253L48.4289 50.0556C47.8133 50.4947 47.8564 51.4239 48.5073 51.8081L73.2739 66.4557C74.2659 67.0398 75.5244 66.8909 76.3478 66.0871L93.3006 49.5929L65.8757 37.5253Z",
    fill: "url(#paint8_linear_722_15901)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3474 65.9385C75.524 66.7422 74.2616 66.8912 73.2736 66.3071L48.5069 51.6595C48.1893 51.4714 48.0168 51.1537 47.9972 50.8244C47.9698 51.2009 48.1423 51.589 48.5069 51.8046L73.2736 66.4521C74.2655 67.0363 75.524 66.8873 76.3474 66.0836L93.3002 49.5895L93.1944 49.5424L76.3474 65.9385Z",
    fill: "url(#paint9_linear_722_15901)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1788 40.427L58.8821 44.8612C58.5176 45.0495 58.5999 45.665 59.0193 45.8807L80.5907 56.7878C81.0612 57.031 81.5709 57.0074 81.9395 56.733L88.1771 51.8792C88.5968 51.5655 88.432 50.7932 87.891 50.5422L67.0371 40.4466C66.4059 40.1525 65.7276 40.1447 65.1788 40.427Z",
    fill: "url(#paint10_linear_722_15901)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.546 45.286L71.5889 45.7956L72.1926 45.3448L71.1536 44.8312L70.546 45.286Z",
    fill: "url(#paint11_linear_722_15901)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0522 44.5551L70.0991 45.0649L70.7068 44.6101L69.664 44.1004L69.0522 44.5551Z",
    fill: "url(#paint12_linear_722_15901)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5619 43.826L68.6087 44.3357L69.2203 43.8809L68.1774 43.3674L67.5619 43.826Z",
    fill: "url(#paint13_linear_722_15901)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5587 44.5748L67.5938 45.0884L68.2564 44.5944L67.2135 44.0847L66.5587 44.5748Z",
    fill: "url(#paint14_linear_722_15901)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1084 44.5607L65.1434 45.0783L65.7668 44.6118L64.7318 44.0981L64.1084 44.5607Z",
    fill: "url(#paint15_linear_722_15901)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0803 43.8389L66.1153 44.3525L66.7662 43.8703L65.7233 43.3606L65.0803 43.8389Z",
    fill: "url(#paint16_linear_722_15901)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0159 47.4689L76.0588 47.9786L76.6547 47.5355L75.6118 47.0259L75.0159 47.4689Z",
    fill: "url(#paint17_linear_722_15901)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5055 48.1975L77.5484 48.7071L78.1403 48.2681L77.0974 47.7544L76.5055 48.1975Z",
    fill: "url(#paint18_linear_722_15901)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9952 48.9227L79.0381 49.4324L79.6262 48.9972L78.5833 48.4876L77.9952 48.9227Z",
    fill: "url(#paint19_linear_722_15901)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M72.036 46.0112L73.0789 46.5209L73.6787 46.0739L72.6397 45.5643L72.036 46.0112Z",
    fill: "url(#paint20_linear_722_15901)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5255 46.7398L74.5684 47.2494L75.1682 46.8064L74.1253 46.2928L73.5255 46.7398Z",
    fill: "url(#paint21_linear_722_15901)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6669 49.7543L72.6317 49.2407L71.9888 49.719L73.0239 50.2365L73.6669 49.7543Z",
    fill: "url(#paint22_linear_722_15901)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1491 50.4917L74.114 49.9782L73.4672 50.4565L74.4983 50.9741L75.1491 50.4917Z",
    fill: "url(#paint23_linear_722_15901)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6269 51.2288L75.5919 50.7112L74.941 51.1974L75.976 51.711L76.6269 51.2288Z",
    fill: "url(#paint24_linear_722_15901)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2453 42.4178L65.4456 42.0219L64.8065 42.4807L65.6259 42.8805L66.2453 42.4178Z",
    fill: "url(#paint25_linear_722_15901)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1889 49.0168L71.1538 48.5031L70.5109 48.9775L71.5459 49.4951L72.1889 49.0168Z",
    fill: "url(#paint26_linear_722_15901)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2723 46.0728L65.2371 45.5553L64.606 46.0258L65.641 46.5433L66.2723 46.0728Z",
    fill: "url(#paint27_linear_722_15901)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1053 51.9663L77.0702 51.4488L76.4194 51.9349L77.4505 52.4525L78.1053 51.9663Z",
    fill: "url(#paint28_linear_722_15901)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2323 47.5479L68.1973 47.0303L67.5582 47.5047L68.5932 48.0223L69.2323 47.5479Z",
    fill: "url(#paint29_linear_722_15901)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7107 48.2815L69.6757 47.7679L69.0366 48.2422L70.0716 48.7598L70.7107 48.2815Z",
    fill: "url(#paint30_linear_722_15901)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5862 45.2961L66.6212 45.8136L67.2485 45.347L66.2096 44.8334L65.5862 45.2961Z",
    fill: "url(#paint31_linear_722_15901)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9972 46.7824L72.0322 47.2999L72.7301 46.7824L71.6872 46.2727L70.9972 46.7824Z",
    fill: "url(#paint32_linear_722_15901)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5146 46.046L70.5537 46.5635L71.2398 46.0538L70.193 45.5441L69.5146 46.046Z",
    fill: "url(#paint33_linear_722_15901)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7269 46.0846L67.6919 45.5709L67.0646 46.0335L68.0996 46.5511L68.7269 46.0846Z",
    fill: "url(#paint34_linear_722_15901)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4751 47.5205L73.5101 48.0381L74.2198 47.5087L73.1769 46.9991L72.4751 47.5205Z",
    fill: "url(#paint35_linear_722_15901)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0367 45.3135L69.0717 45.8271L69.7501 45.3252L68.7033 44.8156L68.0367 45.3135Z",
    fill: "url(#paint36_linear_722_15901)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9535 48.257L74.9885 48.7744L75.7098 48.2373L74.6669 47.7276L73.9535 48.257Z",
    fill: "url(#paint37_linear_722_15901)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0838 42.8885L68.6445 42.4729L67.582 41.975L67.0409 42.3788L68.0838 42.8885Z",
    fill: "url(#paint38_linear_722_15901)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2048 46.8215L69.1698 46.304L68.5425 46.7706L69.5775 47.2881L70.2048 46.8215Z",
    fill: "url(#paint39_linear_722_15901)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4313 48.9933L76.4663 49.5109L77.1994 48.9659L76.1565 48.4562L75.4313 48.9933Z",
    fill: "url(#paint40_linear_722_15901)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6894 49.6967L77.6465 49.187L76.9133 49.7319L77.9484 50.2495L78.6894 49.6967Z",
    fill: "url(#paint41_linear_722_15901)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5991 50.5069L76.5639 49.9894L75.9366 50.4559L76.9757 50.9695L77.5991 50.5069Z",
    fill: "url(#paint42_linear_722_15901)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1791 50.4208L79.1362 49.9112L78.3912 50.4678L79.4263 50.9815L80.1791 50.4208Z",
    fill: "url(#paint43_linear_722_15901)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6731 51.1494L80.6263 50.6397L79.8696 51.2043L80.9047 51.718L81.6731 51.1494Z",
    fill: "url(#paint44_linear_722_15901)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6828 47.5591L70.6477 47.0415L70.0244 47.5081L71.0594 48.0256L71.6828 47.5591Z",
    fill: "url(#paint45_linear_722_15901)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0776 51.2405L78.0425 50.7269L77.4192 51.1895L78.4542 51.7071L79.0776 51.2405Z",
    fill: "url(#paint46_linear_722_15901)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5983 50.4605L81.5593 49.947L80.9751 50.3821L82.0219 50.8918L82.5983 50.4605Z",
    fill: "url(#paint47_linear_722_15901)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1611 48.2966L72.1261 47.779L71.5027 48.2457L72.5377 48.7592L73.1611 48.2966Z",
    fill: "url(#paint48_linear_722_15901)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6429 49.0341L73.6039 48.5166L72.9805 48.9831L74.0156 49.4967L74.6429 49.0341Z",
    fill: "url(#paint49_linear_722_15901)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4852 49.6536L80.532 50.1632L81.1123 49.732L80.0733 49.2183L79.4852 49.6536Z",
    fill: "url(#paint50_linear_722_15901)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1213 49.7694L75.0862 49.2518L74.4589 49.7185L75.4939 50.232L76.1213 49.7694Z",
    fill: "url(#paint51_linear_722_15901)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7545 46.8104L66.7155 46.2928L66.0844 46.7632L67.1155 47.2808L67.7545 46.8104Z",
    fill: "url(#paint52_linear_722_15901)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1179 50.7157L72.1102 51.4646L73.1413 51.9861L74.1529 51.2332L73.1179 50.7157Z",
    fill: "url(#paint53_linear_722_15901)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7832 45.5441L61.8187 46.2616L62.8498 46.783L63.8182 46.0617L62.7832 45.5441Z",
    fill: "url(#paint54_linear_722_15901)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0705 52.1929L75.0511 52.9497L76.0823 53.4711L77.1056 52.7105L76.0705 52.1929Z",
    fill: "url(#paint55_linear_722_15901)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5962 51.4533L73.5808 52.2099L74.6119 52.7274L75.6273 51.9707L74.5962 51.4533Z",
    fill: "url(#paint56_linear_722_15901)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6925 51.9584L59.7523 54.887L65.7666 58.4078L69.8597 55.0439L63.6925 51.9584Z",
    fill: "url(#paint57_linear_722_15901)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5483 52.9306L76.5211 53.6951L77.5483 54.2165L78.5796 53.448L77.5483 52.9306Z",
    fill: "url(#paint58_linear_722_15901)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7352 47.0214L64.759 47.7467L65.7901 48.2682L66.7703 47.5389L65.7352 47.0214Z",
    fill: "url(#paint59_linear_722_15901)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2616 46.2839L63.2893 47.0053L64.3204 47.5228L65.2927 46.8015L64.2616 46.2839Z",
    fill: "url(#paint60_linear_722_15901)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M72.675 50.4955L67.2136 47.7589L66.2295 48.4921L68.0447 49.4095L68.7308 49.7545L69.8561 50.323L70.201 50.4994L71.6713 51.2405L72.675 50.4955Z",
    fill: "url(#paint61_linear_722_15901)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1194 41.7724C66.6724 41.6155 66.2177 41.6195 65.8256 41.7841L66.5979 42.1644L67.1194 41.7724Z",
    fill: "url(#paint62_linear_722_15901)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9584 51.8359L84.9659 52.3299L85.5266 51.8986L84.5307 51.4085L83.9584 51.8359Z",
    fill: "url(#paint63_linear_722_15901)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M85.762 50.4967L84.8799 51.1514L85.8678 51.6376L85.9188 51.5984C86.256 51.3474 86.154 50.7515 85.762 50.4967Z",
    fill: "url(#paint64_linear_722_15901)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4502 44.8782L61.1444 45.0976C60.8307 45.2623 60.9013 45.7916 61.262 45.9799L61.3796 46.0386L62.3402 45.3251L61.4502 44.8782Z",
    fill: "url(#paint65_linear_722_15901)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4614 55.1802L79.8809 55.3919C80.2887 55.5997 80.7278 55.584 81.0454 55.3449L81.5669 54.9411L80.5004 54.4078L79.4614 55.1802Z",
    fill: "url(#paint66_linear_722_15901)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0652 53.4391L80.0262 52.9216L79.3715 53.4117L80.4066 53.9292L81.0652 53.4391Z",
    fill: "url(#paint67_linear_722_15901)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8254 52.6788L83.8487 53.1885L84.6249 52.5925L83.6095 52.0947L82.8254 52.6788Z",
    fill: "url(#paint68_linear_722_15901)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8453 54.1492L81.9078 54.6824L82.5548 54.1806L81.5079 53.6591L80.8453 54.1492Z",
    fill: "url(#paint69_linear_722_15901)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0224 53.6703L77.9913 54.4348L79.0185 54.9563L80.0574 54.1839L79.0224 53.6703Z",
    fill: "url(#paint70_linear_722_15901)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2885 43.8739L63.4417 43.4544L62.8026 43.9132L63.6652 44.3406L64.2885 43.8739Z",
    fill: "url(#paint71_linear_722_15901)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4611 49.468L82.2844 48.8564L81.222 48.3624L80.4221 48.9583L81.4611 49.468Z",
    fill: "url(#paint72_linear_722_15901)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9477 50.2017L83.8024 49.5665L82.7399 49.0686L81.9087 49.688L82.9477 50.2017Z",
    fill: "url(#paint73_linear_722_15901)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9753 48.7399L80.7712 48.1479L79.7086 47.6538L78.9324 48.2263L79.9753 48.7399Z",
    fill: "url(#paint74_linear_722_15901)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4369 50.9297L85.3152 50.275L84.2566 49.777L83.394 50.42L84.4369 50.9297Z",
    fill: "url(#paint75_linear_722_15901)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4891 48.0057L79.2536 47.4372L78.1911 46.9432L77.4462 47.496L78.4891 48.0057Z",
    fill: "url(#paint76_linear_722_15901)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0877 51.1897L83.0448 50.68L82.4685 51.1073L83.5114 51.6209L84.0877 51.1897Z",
    fill: "url(#paint77_linear_722_15901)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5204 51.4644L78.8971 51.927L79.9321 52.4446L80.5555 51.9781L79.5204 51.4644Z",
    fill: "url(#paint78_linear_722_15901)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0033 47.2776L77.7365 46.7287L76.6779 46.2347L75.9604 46.764L77.0033 47.2776Z",
    fill: "url(#paint79_linear_722_15901)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0377 52.7156L81.0025 52.202L80.3752 52.6646L82.8962 53.9231L83.5118 53.4487L82.0377 52.7156Z",
    fill: "url(#paint80_linear_722_15901)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1627 51.8802L82.1159 51.3706L81.3474 51.9429L82.3825 52.4566L83.1627 51.8802Z",
    fill: "url(#paint81_linear_722_15901)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2769 43.1409L64.4497 42.7371L63.7988 43.1997L64.6378 43.6153L65.2769 43.1409Z",
    fill: "url(#paint82_linear_722_15901)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5833 52.7039L78.5483 52.1863L77.8936 52.6724L78.9287 53.19L79.5833 52.7039Z",
    fill: "url(#paint83_linear_722_15901)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1322 45.2844L64.1633 45.8018L64.7945 45.3353L63.7595 44.8177L63.1322 45.2844Z",
    fill: "url(#paint84_linear_722_15901)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3164 44.5987L62.446 44.1674L61.807 44.6222L62.6891 45.0653L63.3164 44.5987Z",
    fill: "url(#paint85_linear_722_15901)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0729 43.0974L67.1158 43.6071L67.7352 43.1524L66.6923 42.6387L66.0729 43.0974Z",
    fill: "url(#paint86_linear_722_15901)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0279 45.8153L74.7062 45.3135L73.6477 44.8156L72.9889 45.3057L74.0279 45.8153Z",
    fill: "url(#paint87_linear_722_15901)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5137 46.5473L76.2233 46.018L75.1608 45.524L74.4747 46.0337L75.5137 46.5473Z",
    fill: "url(#paint88_linear_722_15901)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5417 45.085L73.1924 44.6027L72.13 44.1049L71.5027 44.5714L72.5417 45.085Z",
    fill: "url(#paint89_linear_722_15901)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5694 43.6227L70.1613 43.1836L69.0989 42.6857L68.5265 43.1091L69.5694 43.6227Z",
    fill: "url(#paint90_linear_722_15901)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0556 44.353L71.6751 43.8943L70.6125 43.3963L70.0127 43.8433L71.0556 44.353Z",
    fill: "url(#paint91_linear_722_15901)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.038,
    d: "M87.6681 56.0585C91.4672 53.9611 94.5919 45.0142 94.6507 36.0829C94.7096 27.1478 91.6789 21.6079 87.8837 23.7094C84.0846 25.8069 80.9599 34.7538 80.9011 43.685C80.8384 52.6163 83.869 58.1561 87.6681 56.0585Z",
    fill: "#4A0101"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.077,
    d: "M87.6678 55.6312C91.3649 53.5885 94.4112 44.8808 94.4661 36.1847C94.5209 27.4888 91.5727 22.094 87.8756 24.1366C84.1784 26.1793 81.132 34.887 81.0772 43.5831C81.0222 52.279 83.9706 57.6738 87.6678 55.6312Z",
    fill: "#480202"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.115,
    d: "M87.6716 55.2031C91.2668 53.2154 94.2309 44.7428 94.2857 36.2821C94.3406 27.8213 91.4708 22.5755 87.8754 24.5633C84.2802 26.5511 81.3162 35.0235 81.2614 43.4843C81.2065 51.9411 84.0764 57.1908 87.6716 55.2031Z",
    fill: "#460303"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.154,
    d: "M87.6761 54.7748C91.1734 52.842 94.0511 44.6086 94.1059 36.3832C94.1609 28.1576 91.3694 23.0569 87.876 24.9897C84.3828 26.9226 81.5012 35.1559 81.4462 43.3814C81.3913 51.607 84.1789 56.7077 87.6761 54.7748Z",
    fill: "#440404"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.192,
    d: "M87.676 54.3493C91.0713 52.4714 93.8666 44.4733 93.9216 36.4869C93.9765 28.5006 91.2634 23.5449 87.8681 25.4229C84.4728 27.3009 81.6775 35.299 81.6225 43.2853C81.5715 51.2717 84.2807 56.2234 87.676 54.3493Z",
    fill: "#420505"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.231,
    d: "M87.68 53.9164C90.9774 52.0932 93.6903 44.3343 93.7414 36.5793C93.7923 28.8242 91.1616 24.0175 87.8682 25.8406C84.571 27.6638 81.8579 35.4227 81.8069 43.1777C81.756 50.9326 84.3867 55.7394 87.68 53.9164Z",
    fill: "#400606"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.269,
    d: "M87.6835 53.4888C90.8788 51.7246 93.5096 44.197 93.5605 36.681C93.6116 29.1652 91.0591 24.5036 87.8638 26.2678C84.6686 28.0321 82.0378 35.5597 81.9868 43.0756C81.9358 50.5915 84.4882 55.2571 87.6835 53.4888Z",
    fill: "#3E0606"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.308,
    d: "M87.6875 53.0613C90.781 51.3519 93.3294 44.0634 93.3803 36.7829C93.4273 29.5023 90.9574 24.9896 87.864 26.699C84.7706 28.4083 82.2222 35.6968 82.1712 42.9775C82.1203 50.2581 84.5903 54.7747 87.6875 53.0613Z",
    fill: "#3C0707"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.346,
    d: "M87.6875 52.6351C90.6829 50.9806 93.1489 43.9274 93.1959 36.886C93.243 29.8444 90.8553 25.4729 87.86 27.1274C84.8646 28.782 82.3985 35.8352 82.3515 42.8767C82.3045 49.922 84.696 54.2896 87.6875 52.6351Z",
    fill: "#3A0808"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.385,
    d: "M87.6914 52.207C90.5848 50.6074 92.9686 43.7934 93.0156 36.9832C93.0626 30.1771 90.7534 25.9544 87.856 27.5541C84.9626 29.1537 82.5789 35.9678 82.5318 42.778C82.4847 49.5881 84.798 53.8067 87.6914 52.207Z",
    fill: "#380909"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.423,
    d: "M87.6956 51.781C90.491 50.2364 92.7885 43.6574 92.8316 37.0865C92.8748 30.5155 90.6479 26.438 87.8524 27.9828C85.0571 29.5276 82.7595 36.1064 82.7164 42.6774C82.6733 49.2484 84.9002 53.3258 87.6956 51.781Z",
    fill: "#360A0A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.462,
    d: "M87.6998 51.3536C90.3933 49.8638 92.6124 43.524 92.6515 37.1883C92.6908 30.8525 90.5462 26.9241 87.8527 28.414C85.1593 29.9038 82.9402 36.2434 82.9009 42.5792C82.8539 48.9111 85.0063 52.8434 87.6998 51.3536Z",
    fill: "#340B0B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M87.6994 50.9258C90.2909 49.4908 92.4277 43.3864 92.4669 37.2859C92.506 31.1854 90.4399 27.4058 87.8445 28.8369C85.2529 30.2718 83.1161 36.3763 83.077 42.4768C83.0377 48.5773 85.1078 52.3568 87.6994 50.9258Z",
    fill: "#330C0C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.538,
    d: "M87.7034 50.497C90.197 49.1209 92.2474 43.2517 92.2867 37.3865C92.3258 31.5251 90.3381 27.8868 87.8446 29.2668C85.3511 30.643 83.3006 36.5121 83.2613 42.3775C83.2222 48.2427 85.2099 51.8732 87.7034 50.497Z",
    fill: "#310D0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.577,
    d: "M87.7072 50.0699C90.0988 48.7486 92.067 43.1146 92.1061 37.4885C92.1454 31.8623 90.236 28.373 87.8445 29.6943C85.4528 31.0155 83.4847 36.6494 83.4454 42.2756C83.4063 47.9017 85.3156 51.391 87.7072 50.0699Z",
    fill: "#2F0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M87.7072 49.6437C89.9967 48.3775 91.8865 42.9787 91.9218 37.5917C91.9571 32.2008 90.1301 28.8566 87.8365 30.1229C85.5469 31.3893 83.6571 36.788 83.6219 42.1749C83.5905 47.5658 85.4175 50.9101 87.7072 49.6437Z",
    fill: "#2D0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.654,
    d: "M87.7113 49.2113C89.9029 47.9997 91.7064 42.8402 91.7416 37.6845C91.777 32.529 90.0284 29.3336 87.8368 30.5452C85.6452 31.7566 83.8417 36.9162 83.8063 42.0718C83.7711 47.2275 85.5196 50.4228 87.7113 49.2113Z",
    fill: "#2B1010"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.692,
    d: "M87.715 48.7838C89.8047 47.6272 91.5259 42.7029 91.5612 37.7864C91.5925 32.87 89.9262 29.8197 87.8366 30.9723C85.7469 32.129 84.0258 37.0532 83.9904 41.9697C83.9552 46.8862 85.6254 49.9404 87.715 48.7838Z",
    fill: "#291111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.731,
    d: "M87.719 48.3576C89.7107 47.2559 91.3495 42.5707 91.3808 37.8895C91.4122 33.2082 89.8244 30.303 87.8327 31.4047C85.8411 32.5065 84.2022 37.1916 84.1709 41.8728C84.1395 46.5541 85.7273 49.4593 87.719 48.3576Z",
    fill: "#271212"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.769,
    d: "M87.7193 47.9297C89.6091 46.8868 91.1656 42.4331 91.197 37.987C91.2283 33.541 89.7188 30.7848 87.8291 31.8277C85.9394 32.8706 84.3829 37.3244 84.3514 41.7704C84.3241 46.2164 85.8296 48.9766 87.7193 47.9297Z",
    fill: "#251212"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.808,
    d: "M87.7232 47.5035C89.511 46.5155 90.9852 42.3008 91.0126 38.0901C91.0401 33.8792 89.6129 31.2681 87.8251 32.2601C86.0373 33.2481 84.5631 37.4628 84.5358 41.6735C84.5043 45.8843 85.9353 48.4914 87.7232 47.5035Z",
    fill: "#231313"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.846,
    d: "M87.7268 47.0761C89.4167 46.1429 90.8085 42.1635 90.832 38.1919C90.8595 34.2202 89.5107 31.7542 87.821 32.6872C86.1311 33.6204 84.7393 37.5999 84.7158 41.5714C84.6923 45.5431 86.0371 48.0091 87.7268 47.0761Z",
    fill: "#211414"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.885,
    d: "M87.7309 46.6486C89.3187 45.7703 90.6282 42.0301 90.6518 38.2936C90.6753 34.5572 89.4089 32.2402 87.8211 33.1184C86.2332 33.9966 84.9238 37.7369 84.9002 41.4732C84.8728 45.2097 86.1391 47.5268 87.7309 46.6486Z",
    fill: "#1F1515"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.923,
    d: "M87.7306 46.2197C89.2204 45.3964 90.4436 41.8914 90.4671 38.3902C90.4907 34.8891 89.3027 32.717 87.8128 33.5404C86.323 34.3637 85.0997 37.8688 85.0763 41.3699C85.0566 44.8711 86.2446 47.043 87.7306 46.2197Z",
    fill: "#1D1616"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.962,
    d: "M87.7349 45.7922C89.1228 45.0238 90.2637 41.7579 90.2872 38.4921C90.3107 35.2262 89.2012 33.2031 87.8133 33.9715C86.4254 34.74 85.2845 38.0059 85.261 41.2717C85.2413 44.5337 86.347 46.5568 87.7349 45.7922Z",
    fill: "#1B1717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7391 45.3648C89.025 44.6513 90.0876 41.6205 90.1071 38.5938C90.1267 35.5671 89.0995 33.6891 87.8135 34.3988C86.5276 35.1084 85.4651 38.1429 85.4455 41.1697C85.422 44.1964 86.4492 46.0744 87.7391 45.3648Z",
    fill: "#191818"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6114 12.9138L58.2047 35.2574C58.0675 35.9514 58.4243 36.6454 59.0633 36.9434L82.493 47.7447C83.3399 48.1367 84.3318 47.6427 84.5279 46.7292L89.8364 22.2879C90.0168 21.449 89.5463 20.6061 88.7386 20.3238L64.5444 11.816C63.6975 11.5141 62.7879 12.0355 62.6114 12.9138Z",
    fill: "url(#paint92_linear_722_15901)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9017 13.0987L57.491 35.4384C57.3538 36.1324 57.7106 36.8263 58.3496 37.1243L81.7793 47.9257C82.6262 48.3177 83.6181 47.8238 83.8142 46.9103L89.1227 22.469C89.303 21.63 88.8325 20.787 88.0249 20.5047L63.8306 11.997C62.9877 11.6951 62.0741 12.2165 61.9017 13.0987Z",
    fill: "url(#paint93_linear_722_15901)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M82.391 47.0665C82.3243 47.0665 82.2577 47.0508 82.195 47.0233L58.7652 36.222C58.5378 36.1162 58.4123 35.873 58.4594 35.6261L62.87 13.2863C62.9211 13.0314 63.1484 12.8942 63.3445 12.8942C63.3994 12.8942 63.4543 12.902 63.5052 12.9217L87.6995 21.4295C88.0367 21.547 88.2366 21.9038 88.1582 22.2528L82.8497 46.694C82.7987 46.9411 82.5831 47.0665 82.391 47.0665Z",
    fill: "url(#paint94_linear_722_15901)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0753 28.8295L70.3251 24.211C70.0977 24.1208 69.9487 23.8503 69.9957 23.6073C70.0389 23.3641 70.2624 23.2387 70.4858 23.325L82.236 27.9435C82.4634 28.0337 82.6124 28.3042 82.5654 28.5473C82.5223 28.7903 82.2988 28.9158 82.0753 28.8295Z",
    fill: "#D6D0D0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M81.048 23.3099L69.2272 18.9462C68.9999 18.8639 68.8509 18.5973 68.894 18.3541C68.9372 18.1111 69.1606 17.9817 69.388 18.068L81.2087 22.4317C81.4361 22.5139 81.5851 22.7806 81.542 23.0237C81.4949 23.2629 81.2753 23.3922 81.048 23.3099Z",
    fill: "#D6D0D0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8727 29.7387L69.9571 26.2336C69.7298 26.1435 69.5808 25.873 69.6278 25.6298C69.671 25.3868 69.8944 25.2613 70.1179 25.3475L79.0334 28.8527C79.2608 28.9428 79.4098 29.2133 79.3628 29.4564C79.3196 29.6994 79.0961 29.8288 78.8727 29.7387Z",
    fill: "#D6D0D0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3607 21.4773L68.5107 22.233C68.7402 22.3131 68.87 22.5527 68.8144 22.7914L68.2375 25.2763C68.186 25.4981 67.9506 25.628 67.7389 25.5521L65.4843 24.744C65.2945 24.6766 65.1866 24.4792 65.2296 24.281L65.7568 21.8197C65.8166 21.5472 66.1018 21.3862 66.3607 21.4773Z",
    fill: "url(#paint95_linear_722_15901)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8738 23.2039L66.4773 24.1475L67.945 23.4027L67.812 23.2029L66.5471 23.8212L66.0828 23.0622L65.8738 23.2039Z",
    fill: "#F4F4F4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1501 33.9028L69.4 29.2843C69.1726 29.1941 69.0237 28.9236 69.0707 28.6806C69.1138 28.4374 69.3373 28.312 69.5608 28.3983L81.3109 33.0167C81.5383 33.107 81.6873 33.3775 81.6402 33.6205C81.5971 33.8636 81.3775 33.9891 81.1501 33.9028Z",
    fill: "#D6D0D0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9472 34.812L69.0316 31.3069C68.8042 31.2167 68.6552 30.9462 68.7023 30.7031C68.7453 30.46 68.9688 30.3346 69.1923 30.4208L78.1079 33.9259C78.3353 34.0161 78.4843 34.2866 78.4373 34.5297C78.3941 34.7727 78.1745 34.8982 77.9472 34.812Z",
    fill: "#D6D0D0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1852 26.1818L67.3351 26.9376C67.5646 27.0177 67.6946 27.2572 67.6388 27.4959L67.0619 29.9808C67.0105 30.2026 66.7751 30.3326 66.5634 30.2566L64.3089 29.4486C64.119 29.3811 64.0111 29.1837 64.054 28.9855L64.5812 26.5243C64.6412 26.2518 64.9262 26.0907 65.1852 26.1818Z",
    fill: "url(#paint96_linear_722_15901)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6986 27.9084L65.3021 28.8521L66.7697 28.1073L66.6368 27.9075L65.3719 28.5256L64.9076 27.7667L64.6986 27.9084Z",
    fill: "#F4F4F4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2287 38.9738L68.4785 34.3553C68.2511 34.2651 68.1021 33.9946 68.1492 33.7515C68.1924 33.5085 68.4157 33.383 68.6392 33.4693L80.3894 38.0878C80.6168 38.178 80.7658 38.4485 80.7188 38.6915C80.6756 38.9386 80.4521 39.064 80.2287 38.9738Z",
    fill: "#D6D0D0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0253 39.8829L68.1097 36.3779C67.8824 36.2877 67.7334 36.0172 67.7804 35.7742C67.8235 35.531 68.047 35.4056 68.2705 35.4919L77.186 38.9969C77.4134 39.0871 77.5624 39.3576 77.5153 39.6006C77.4722 39.8477 77.2487 39.9731 77.0253 39.8829Z",
    fill: "#D6D0D0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0077 31.2797L66.1577 32.0354C66.3871 32.1156 66.517 32.3551 66.4614 32.5938L65.8844 35.0787C65.833 35.3004 65.5976 35.4303 65.3859 35.3545L63.1313 34.5464C62.9415 34.479 62.8336 34.2816 62.8766 34.0834L63.4038 31.6221C63.4636 31.3496 63.7488 31.1886 64.0077 31.2797Z",
    fill: "url(#paint97_linear_722_15901)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5204 33.0063L64.1239 33.9498L65.5915 33.205L65.4586 33.0054L64.1937 33.6235L63.7293 32.8645L63.5204 33.0063Z",
    fill: "#F4F4F4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8544 27.9446L103.848 31.4575C104.915 31.83 105.518 32.9435 105.26 34.0529L102.578 45.6032C102.339 46.6343 101.245 47.238 100.261 46.8852L89.7809 43.1292C88.8988 42.8156 88.3969 41.8981 88.5968 40.9767L91.0473 29.5364C91.3255 28.27 92.6507 27.5212 93.8544 27.9446Z",
    fill: "url(#paint98_linear_722_15901)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6783 28.3357L102.672 31.8486C103.738 32.2211 104.342 33.3346 104.083 34.4441L101.402 45.9943C101.163 47.0254 100.069 47.6291 99.0845 47.2763L88.6046 43.5204C87.7225 43.2067 87.2207 42.2892 87.4206 41.3679L89.871 29.9275C90.1494 28.6611 91.4746 27.9123 92.6783 28.3357Z",
    fill: "url(#paint99_linear_722_15901)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9666 36.7714C90.82 36.9252 90.8225 37.1677 90.9723 37.3184L94.1234 40.4886C94.2654 40.6314 94.4927 40.6434 94.649 40.5163L99.9658 36.1905C100.148 36.0423 100.16 35.7683 99.9911 35.6048L99.7534 35.3742C99.6123 35.2375 99.3918 35.2262 99.2375 35.3479L94.6493 38.9677C94.4906 39.0929 94.2626 39.0769 94.123 38.9307L91.7969 36.4953C91.6424 36.3335 91.384 36.3336 91.2295 36.4955L90.9666 36.7714Z",
    fill: "#F4F4F4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8455 40.7653L90.6943 37.5951C90.3949 37.2938 90.3897 36.8087 90.6829 36.5012L90.9459 36.2254C91.2547 35.9015 91.7714 35.9013 92.0805 36.2249L94.4066 38.6603L98.9949 35.0405C99.3033 34.7971 99.7443 34.8196 100.026 35.0931L100.264 35.3238C100.601 35.6507 100.578 36.1986 100.213 36.4949L94.8966 40.8208C94.5839 41.075 94.1295 41.0511 93.8455 40.7653ZM90.9724 37.3187C90.8226 37.168 90.8201 36.9255 90.9666 36.7718L91.2297 36.4959C91.3841 36.3339 91.6425 36.3338 91.7969 36.4956L94.123 38.931C94.2627 39.0772 94.4907 39.0933 94.6494 38.9681L99.2377 35.3483C99.392 35.2266 99.6124 35.2378 99.7534 35.3746L99.9913 35.6053C100.16 35.7687 100.148 36.0426 99.9658 36.1908L94.649 40.5166C94.4927 40.6438 94.2656 40.6319 94.1236 40.4889L90.9724 37.3187Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M113.555 70.1936C113.555 70.1936 115.323 67.9275 115.021 65.3241C115.021 65.3241 112.265 65.0889 110.297 67.2256L113.555 70.1936Z",
    fill: "url(#paint100_linear_722_15901)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M103.667 74.5014L110.171 67.3385C110.391 67.0955 110.771 67.0013 111.257 67.1071C111.312 67.1189 111.371 67.1346 111.426 67.1503C111.446 67.1543 111.461 67.162 111.481 67.1659C111.504 67.1738 111.532 67.1816 111.555 67.1895C111.567 67.1934 111.579 67.1973 111.587 67.2013C111.626 67.217 111.665 67.2326 111.704 67.2483C111.724 67.2561 111.74 67.264 111.759 67.2718C111.767 67.2758 111.775 67.2797 111.787 67.2836C111.81 67.2954 111.838 67.3071 111.861 67.3189C111.885 67.3306 111.904 67.3424 111.928 67.3503C111.94 67.3581 111.951 67.366 111.963 67.3699C111.983 67.3816 112.002 67.3934 112.022 67.4012C112.037 67.4091 112.057 67.4208 112.073 67.4287C112.092 67.4405 112.108 67.4522 112.128 67.4639C112.132 67.4639 112.132 67.4679 112.136 67.4679C112.151 67.4757 112.167 67.4875 112.183 67.4953C112.19 67.4993 112.198 67.507 112.206 67.5109C112.249 67.5384 112.288 67.5698 112.332 67.5972L112.335 67.6012C112.343 67.6051 112.347 67.609 112.355 67.6169C112.387 67.6404 112.422 67.6639 112.453 67.6914C112.465 67.6992 112.477 67.711 112.488 67.7187C112.504 67.7305 112.516 67.7423 112.532 67.7541C112.543 67.7659 112.559 67.7737 112.571 67.7855C112.598 67.8089 112.626 67.8325 112.653 67.8599C112.661 67.8677 112.669 67.8756 112.677 67.8795C112.681 67.8834 112.681 67.8834 112.684 67.8874C112.724 67.9227 112.759 67.9579 112.798 67.9971C112.802 68.001 112.81 68.0089 112.814 68.0128C112.826 68.0246 112.841 68.0403 112.853 68.0521C112.873 68.0716 112.892 68.0912 112.912 68.1148C112.924 68.1266 112.935 68.1422 112.947 68.154C112.963 68.1736 112.979 68.1893 112.994 68.2088C113.006 68.2206 113.018 68.2363 113.029 68.2481C113.041 68.2638 113.057 68.2833 113.069 68.299C113.088 68.3226 113.108 68.35 113.128 68.3735C113.135 68.3853 113.147 68.3932 113.155 68.4048C113.167 68.4166 113.175 68.4323 113.182 68.4441C113.214 68.4872 113.241 68.5304 113.269 68.5695C113.277 68.5853 113.288 68.597 113.296 68.6088C113.304 68.6205 113.312 68.6362 113.32 68.648C113.331 68.6676 113.343 68.6911 113.359 68.7107C113.378 68.746 113.398 68.7813 113.418 68.8127C113.429 68.8322 113.441 68.8558 113.449 68.8754C113.457 68.8872 113.461 68.9028 113.469 68.9146C113.48 68.9381 113.492 68.9655 113.5 68.9891C113.508 69.0048 113.516 69.0244 113.523 69.0439C113.547 69.0989 113.567 69.1538 113.586 69.2126C113.602 69.2674 113.618 69.3184 113.629 69.3694C113.633 69.3811 113.637 69.3968 113.637 69.4086C113.641 69.4243 113.645 69.4361 113.645 69.4517C113.649 69.4674 113.649 69.4791 113.649 69.4949C113.657 69.534 113.661 69.5733 113.661 69.6124C113.661 69.6242 113.665 69.6399 113.665 69.6478C113.665 69.6595 113.665 69.6712 113.665 69.683C113.665 69.7066 113.665 69.7261 113.665 69.7497C113.665 69.7614 113.665 69.7771 113.665 69.7889C113.665 69.8045 113.661 69.8163 113.661 69.832C113.661 69.8477 113.657 69.8633 113.657 69.879C113.657 69.8869 113.657 69.8987 113.653 69.9065C113.649 69.9301 113.641 69.9575 113.637 69.981C113.633 69.9889 113.633 69.9967 113.633 70.0046V70.0123C113.625 70.0437 113.614 70.075 113.602 70.1025C113.602 70.1065 113.598 70.1104 113.594 70.1182C113.59 70.1261 113.586 70.1339 113.582 70.1456C113.574 70.1613 113.57 70.1731 113.563 70.1888C113.555 70.2006 113.547 70.2124 113.539 70.224C113.535 70.2319 113.531 70.2398 113.523 70.2476C113.52 70.2515 113.52 70.2555 113.516 70.2633C113.5 70.2868 113.48 70.3103 113.461 70.3339C113.457 70.3378 113.457 70.3378 113.453 70.3417L106.976 77.4773L106.968 77.4852C106.988 77.4616 107.003 77.442 107.019 77.4184C107.023 77.4107 107.031 77.4028 107.035 77.395C107.051 77.3675 107.066 77.3439 107.078 77.3165C107.082 77.3087 107.086 77.3008 107.09 77.289C107.105 77.2538 107.117 77.2185 107.129 77.1793C107.133 77.1715 107.133 77.1636 107.133 77.1557C107.141 77.1244 107.149 77.0891 107.152 77.0578C107.156 77.0421 107.156 77.0264 107.156 77.0107C107.16 76.9833 107.16 76.9558 107.16 76.9245C107.16 76.9009 107.16 76.8813 107.16 76.8577C107.16 76.8343 107.156 76.8107 107.156 76.7832C107.152 76.7441 107.149 76.7088 107.145 76.6657C107.141 76.6383 107.137 76.6108 107.129 76.5833C107.125 76.5716 107.125 76.5559 107.121 76.5441C107.109 76.4932 107.098 76.4423 107.078 76.3873C107.058 76.3324 107.039 76.2736 107.015 76.2188C107.007 76.1991 106.999 76.1834 106.992 76.1639C106.976 76.1246 106.956 76.0894 106.941 76.0501C106.937 76.0384 106.929 76.0266 106.925 76.0149C106.921 76.007 106.913 75.9953 106.909 75.9874C106.89 75.9522 106.87 75.9168 106.851 75.8854C106.839 75.8659 106.827 75.8423 106.811 75.8227C106.796 75.7953 106.776 75.7678 106.76 75.7444C106.733 75.7012 106.706 75.6581 106.674 75.6188C106.654 75.5954 106.639 75.5718 106.619 75.5443C106.6 75.5209 106.58 75.4934 106.56 75.4698C106.537 75.4385 106.513 75.411 106.486 75.3797C106.47 75.3601 106.455 75.3405 106.439 75.3249C106.408 75.2895 106.376 75.2582 106.345 75.2229C106.333 75.2111 106.321 75.1955 106.306 75.1837C106.262 75.1405 106.215 75.0935 106.168 75.0504C106.16 75.0426 106.153 75.0347 106.145 75.0308C106.106 74.9955 106.063 74.9602 106.023 74.9249C106.008 74.9132 105.996 74.9014 105.98 74.8896C105.937 74.8543 105.894 74.8191 105.847 74.7877C105.839 74.7837 105.835 74.7798 105.827 74.7721C105.776 74.7367 105.725 74.7015 105.674 74.6661C105.659 74.6583 105.643 74.6465 105.627 74.6388C105.6 74.6231 105.576 74.6074 105.549 74.5916C105.537 74.5838 105.525 74.5759 105.51 74.5682C105.49 74.5564 105.47 74.5446 105.451 74.5368C105.416 74.5171 105.38 74.5014 105.349 74.4819C105.325 74.4701 105.298 74.4584 105.274 74.4466C105.247 74.4348 105.22 74.4231 105.192 74.4113C105.153 74.3956 105.114 74.3799 105.074 74.3642C105.039 74.3525 105.004 74.3368 104.969 74.3251C104.949 74.3172 104.933 74.3133 104.914 74.3094C104.859 74.2936 104.8 74.278 104.745 74.2663C104.29 74.1682 103.926 74.2466 103.702 74.4544C103.691 74.4662 103.679 74.478 103.667 74.4898V74.5014Z",
    fill: "url(#paint101_linear_722_15901)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M107.078 76.3887C107.384 77.3453 106.839 77.9531 105.859 77.7414C104.882 77.5297 103.84 76.5808 103.534 75.6242C103.228 74.6636 103.777 74.0599 104.753 74.2716C105.733 74.4794 106.772 75.4282 107.078 76.3887Z",
    fill: "url(#paint102_linear_722_15901)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2762 81.5214L103.781 74.3584C104 74.1153 104.38 74.0212 104.867 74.127C104.922 74.1388 104.98 74.1545 105.035 74.1702C105.055 74.1741 105.07 74.182 105.09 74.1859C105.114 74.1938 105.141 74.2015 105.165 74.2094C105.176 74.2133 105.188 74.2172 105.196 74.2211C105.235 74.2368 105.274 74.2525 105.314 74.2682C105.333 74.276 105.349 74.2839 105.368 74.2917C105.376 74.2956 105.384 74.2996 105.396 74.3035C105.419 74.3153 105.447 74.3269 105.47 74.3387C105.494 74.3505 105.514 74.3623 105.537 74.3701C105.549 74.378 105.561 74.3858 105.572 74.3898C105.592 74.4014 105.612 74.4132 105.631 74.4211C105.647 74.4289 105.666 74.4407 105.682 74.4486C105.702 74.4603 105.717 74.472 105.737 74.4838C105.741 74.4838 105.741 74.4877 105.745 74.4877C105.76 74.4956 105.776 74.5074 105.792 74.5152C105.8 74.5191 105.808 74.527 105.815 74.5309C105.859 74.5583 105.898 74.5897 105.941 74.6171L105.945 74.621C105.953 74.6249 105.957 74.6289 105.964 74.6367C105.996 74.6603 106.031 74.6837 106.062 74.7112C106.074 74.7191 106.086 74.7309 106.098 74.7387C106.113 74.7504 106.125 74.7622 106.141 74.7739C106.153 74.7857 106.168 74.7936 106.18 74.8054C106.207 74.8288 106.235 74.8524 106.262 74.8799C106.27 74.8876 106.278 74.8955 106.286 74.8994C106.29 74.9033 106.29 74.9033 106.294 74.9072C106.333 74.9426 106.368 74.9778 106.407 75.0171C106.411 75.021 106.419 75.0288 106.423 75.0327C106.435 75.0445 106.451 75.0602 106.462 75.0719C106.482 75.0916 106.502 75.1111 106.521 75.1347C106.533 75.1464 106.545 75.162 106.556 75.1738C106.572 75.1935 106.588 75.2092 106.603 75.2288C106.615 75.2405 106.627 75.2562 106.639 75.268C106.651 75.2837 106.666 75.3032 106.678 75.3189C106.698 75.3425 106.717 75.3698 106.737 75.3934C106.745 75.4052 106.756 75.413 106.764 75.4248C106.776 75.4366 106.784 75.4522 106.792 75.464C106.823 75.5071 106.851 75.5503 106.878 75.5894C106.886 75.6051 106.898 75.6169 106.905 75.6287C106.913 75.6405 106.921 75.6561 106.929 75.6678C106.941 75.6875 106.952 75.7109 106.968 75.7306C106.988 75.7659 107.007 75.8011 107.027 75.8325C107.039 75.8522 107.05 75.8756 107.058 75.8953C107.066 75.907 107.07 75.9228 107.078 75.9344C107.09 75.958 107.101 75.9855 107.109 76.0089C107.117 76.0246 107.125 76.0443 107.133 76.0638C107.156 76.1188 107.176 76.1736 107.196 76.2324C107.211 76.2873 107.227 76.3382 107.239 76.3893C107.243 76.4011 107.246 76.4167 107.246 76.4284C107.25 76.4441 107.254 76.4559 107.254 76.4715C107.258 76.4872 107.258 76.499 107.258 76.5147C107.266 76.5539 107.27 76.5931 107.27 76.6323C107.27 76.6441 107.274 76.6598 107.274 76.6676C107.274 76.6794 107.274 76.6911 107.274 76.7029C107.274 76.7264 107.274 76.7461 107.274 76.7695C107.274 76.7813 107.274 76.797 107.274 76.8088C107.274 76.8244 107.27 76.8362 107.27 76.8519C107.27 76.8676 107.266 76.8833 107.266 76.8989C107.266 76.9068 107.266 76.9185 107.262 76.9264C107.258 76.9499 107.25 76.9773 107.246 77.0009C107.243 77.0087 107.243 77.0166 107.243 77.0243V77.0322C107.235 77.0636 107.223 77.095 107.211 77.1224C107.211 77.1263 107.207 77.1303 107.203 77.1381C107.199 77.146 107.196 77.1538 107.192 77.1656C107.184 77.1812 107.18 77.193 107.172 77.2087C107.164 77.2205 107.156 77.2322 107.149 77.2439C107.144 77.2518 107.141 77.2596 107.133 77.2675C107.129 77.2714 107.129 77.2753 107.125 77.2832C107.109 77.3066 107.09 77.3302 107.07 77.3537C107.066 77.3577 107.066 77.3577 107.062 77.3616L100.585 84.4972L100.577 84.5049C100.597 84.4815 100.613 84.4618 100.628 84.4384C100.632 84.4305 100.64 84.4227 100.644 84.4148C100.66 84.3873 100.675 84.3639 100.687 84.3364C100.691 84.3285 100.695 84.3207 100.699 84.3089C100.715 84.2737 100.726 84.2383 100.738 84.1992C100.742 84.1913 100.742 84.1835 100.742 84.1756C100.75 84.1443 100.758 84.109 100.762 84.0777C100.766 84.062 100.766 84.0462 100.766 84.0305C100.77 84.0032 100.77 83.9757 100.77 83.9444C100.77 83.9208 100.77 83.9012 100.77 83.8777C100.77 83.8542 100.766 83.8306 100.766 83.8032C100.762 83.764 100.758 83.7287 100.754 83.6855C100.75 83.6581 100.746 83.6307 100.738 83.6033C100.734 83.5915 100.734 83.5758 100.73 83.564C100.719 83.5131 100.707 83.4621 100.687 83.4072C100.668 83.3523 100.648 83.2935 100.625 83.2386C100.617 83.219 100.609 83.2033 100.601 83.1838C100.585 83.1445 100.566 83.1093 100.55 83.07C100.546 83.0582 100.538 83.0465 100.534 83.0348C100.53 83.0269 100.523 83.0151 100.519 83.0073C100.499 82.972 100.479 82.9367 100.46 82.9054C100.448 82.8858 100.436 82.8622 100.421 82.8427C100.405 82.8152 100.385 82.7877 100.37 82.7642C100.342 82.7211 100.315 82.678 100.283 82.6387C100.264 82.6152 100.248 82.5917 100.228 82.5643C100.209 82.5407 100.189 82.5133 100.17 82.4898C100.146 82.4584 100.123 82.4309 100.095 82.3996C100.079 82.38 100.064 82.3603 100.048 82.3447C100.017 82.3094 99.9854 82.2781 99.9541 82.2427C99.9423 82.231 99.9305 82.2154 99.9148 82.2036C99.8717 82.1604 99.8247 82.1134 99.7776 82.0703C99.7699 82.0624 99.762 82.0546 99.7542 82.0507C99.7149 82.0153 99.6718 81.9801 99.6325 81.9447C99.6169 81.9331 99.6052 81.9213 99.5894 81.9095C99.5464 81.8743 99.5032 81.8389 99.4562 81.8075C99.4483 81.8037 99.4444 81.7998 99.4365 81.7919C99.3856 81.7566 99.3346 81.7214 99.2837 81.686C99.268 81.6782 99.2523 81.6665 99.2366 81.6586C99.2092 81.6429 99.1856 81.6272 99.1582 81.6115C99.1465 81.6038 99.1347 81.5959 99.119 81.5881C99.0994 81.5763 99.0797 81.5645 99.0602 81.5566C99.0249 81.537 98.9896 81.5214 98.9582 81.5018C98.9348 81.49 98.9073 81.4782 98.8837 81.4664C98.8563 81.4548 98.8289 81.443 98.8015 81.4312C98.7622 81.4155 98.723 81.3998 98.6838 81.3842C98.6485 81.3724 98.6132 81.3567 98.578 81.3449C98.5583 81.3371 98.5426 81.3331 98.523 81.3292C98.4681 81.3136 98.4093 81.2979 98.3545 81.2861C97.8996 81.1882 97.5351 81.2665 97.3116 81.4743C97.2998 81.4861 97.288 81.4979 97.2762 81.5096V81.5214Z",
    fill: "url(#paint103_linear_722_15901)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M100.687 83.4063C100.993 84.3629 100.448 84.9707 99.468 84.759C98.4918 84.5473 97.4489 83.5985 97.143 82.6418C96.8373 81.6813 97.3861 81.0775 98.3624 81.2892C99.3426 81.5009 100.381 82.4497 100.687 83.4063Z",
    fill: "url(#paint104_linear_722_15901)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8693 84.7155L97.3393 81.9827C97.5235 81.7828 97.8412 81.7004 98.245 81.7906C98.292 81.8024 98.3391 81.8142 98.3861 81.826C98.4018 81.8299 98.4174 81.8337 98.4292 81.8416C98.4488 81.8494 98.4724 81.8534 98.4919 81.8612C98.4998 81.8651 98.5116 81.8691 98.5194 81.873C98.5508 81.8848 98.5861 81.9005 98.6175 81.9121C98.6331 81.92 98.6488 81.9239 98.6645 81.9318C98.6723 81.9357 98.6802 81.9396 98.688 81.9436C98.7076 81.9553 98.7311 81.9632 98.7508 81.9749C98.7703 81.9827 98.786 81.9945 98.8056 82.0024C98.8174 82.0063 98.8253 82.0141 98.8369 82.0181C98.8526 82.0259 98.8683 82.0377 98.888 82.0454C98.9036 82.0533 98.9154 82.0611 98.9311 82.069C98.9468 82.0769 98.9625 82.0886 98.9781 82.0965C98.9781 82.0965 98.982 82.1004 98.9859 82.1004C98.9977 82.1083 99.0134 82.116 99.0252 82.1239C99.0329 82.1278 99.037 82.1317 99.0447 82.1357C99.0801 82.1592 99.1153 82.1827 99.1506 82.2062C99.1506 82.2062 99.1546 82.2062 99.1546 82.2102C99.1585 82.2141 99.1663 82.218 99.1703 82.2219C99.1976 82.2416 99.2251 82.2611 99.2525 82.2846C99.2643 82.2925 99.2722 82.3004 99.2839 82.3082C99.2957 82.3161 99.3075 82.3277 99.3192 82.3356C99.3309 82.3434 99.3427 82.3513 99.3506 82.3631C99.3741 82.3827 99.3976 82.4022 99.4172 82.4258C99.4251 82.4297 99.429 82.4376 99.4369 82.4415C99.4408 82.4415 99.4408 82.4454 99.4447 82.4454C99.476 82.4728 99.5074 82.5042 99.5387 82.5355C99.5427 82.5395 99.5466 82.5434 99.5505 82.5512C99.5623 82.563 99.5741 82.5748 99.5819 82.5826C99.5975 82.5983 99.6132 82.6179 99.6329 82.6336C99.6407 82.6454 99.6525 82.6532 99.6604 82.6649C99.672 82.6806 99.6877 82.6963 99.6995 82.712C99.7074 82.7238 99.7191 82.7355 99.727 82.7433C99.7387 82.759 99.7505 82.7708 99.7583 82.7865C99.774 82.806 99.7935 82.8296 99.8093 82.8492C99.8171 82.8571 99.825 82.8649 99.8289 82.8766C99.8367 82.8884 99.8446 82.9002 99.8524 82.908C99.8798 82.9433 99.9034 82.9786 99.9269 83.0138C99.9348 83.0256 99.9426 83.0374 99.9504 83.0492C99.9583 83.061 99.9622 83.0688 99.97 83.0805C99.9818 83.0962 99.9897 83.1158 100.001 83.1315C100.017 83.1589 100.033 83.1903 100.048 83.2177C100.056 83.2334 100.068 83.253 100.076 83.2688C100.08 83.2804 100.088 83.2922 100.092 83.3001C100.103 83.3197 100.111 83.3393 100.119 83.3628C100.127 83.3785 100.131 83.3903 100.139 83.406C100.158 83.453 100.174 83.5 100.19 83.5471C100.205 83.5902 100.213 83.6333 100.225 83.6765C100.229 83.6883 100.229 83.6999 100.233 83.7117C100.237 83.7235 100.237 83.7353 100.241 83.7471C100.245 83.7588 100.245 83.7705 100.245 83.7823C100.248 83.8176 100.252 83.8489 100.256 83.8804C100.256 83.8921 100.26 83.9 100.26 83.9118C100.26 83.9234 100.26 83.9313 100.26 83.9431C100.26 83.9627 100.26 83.9783 100.26 83.9979C100.26 84.0097 100.26 84.0215 100.26 84.0333C100.26 84.0451 100.256 84.0567 100.256 84.0685C100.256 84.0803 100.252 84.096 100.252 84.1078C100.252 84.1155 100.252 84.1234 100.248 84.1312C100.245 84.1509 100.24 84.1705 100.237 84.194C100.237 84.2018 100.233 84.2057 100.233 84.2136V84.2175C100.225 84.245 100.217 84.2685 100.205 84.292C100.205 84.2959 100.201 84.2999 100.201 84.3038C100.197 84.3116 100.193 84.3195 100.19 84.3233C100.186 84.3351 100.178 84.3469 100.174 84.3587C100.17 84.3704 100.162 84.3783 100.154 84.3901C100.15 84.3978 100.146 84.4018 100.143 84.4096C100.139 84.4135 100.139 84.4175 100.135 84.4214C100.119 84.441 100.107 84.4605 100.088 84.4802C100.088 84.4841 100.084 84.4841 100.084 84.488L97.6334 87.1972L97.6294 87.2011C97.6451 87.1815 97.6607 87.1658 97.6725 87.1423C97.6764 87.1345 97.6804 87.1306 97.6843 87.1227C97.6961 87.0991 97.7079 87.0796 97.7195 87.0561C97.7235 87.0482 97.7274 87.0404 97.7313 87.0325C97.7431 87.0012 97.7549 86.9737 97.7627 86.9424C97.7627 86.9345 97.7666 86.9306 97.7666 86.9228C97.7745 86.8953 97.7784 86.8679 97.7824 86.8404C97.7863 86.8286 97.7863 86.813 97.7863 86.8013C97.7901 86.7777 97.7901 86.7541 97.7901 86.7307C97.7901 86.711 97.7901 86.6953 97.7901 86.6758C97.7901 86.6562 97.7863 86.6365 97.7863 86.6169C97.7824 86.5856 97.7784 86.5542 97.7745 86.519C97.7706 86.4954 97.7667 86.4718 97.7627 86.4484C97.7588 86.4366 97.7588 86.4248 97.7549 86.413C97.7431 86.37 97.7352 86.3269 97.7195 86.2837C97.7039 86.2367 97.6882 86.1895 97.6686 86.1425C97.6607 86.1268 97.6568 86.1112 97.6491 86.0994C97.6373 86.068 97.6216 86.0367 97.6059 86.0053C97.6019 85.9975 97.598 85.9858 97.5902 85.9779C97.5862 85.9701 97.5823 85.9622 97.5785 85.9544C97.5628 85.9269 97.5471 85.8956 97.5314 85.8681C97.5196 85.8524 97.5117 85.8329 97.5001 85.8171C97.4883 85.7936 97.4726 85.7741 97.4569 85.7505C97.4334 85.7152 97.4099 85.6799 97.3863 85.6446C97.3707 85.6251 97.355 85.6054 97.3432 85.5819C97.3275 85.5623 97.3118 85.5388 97.2923 85.5191C97.2726 85.4957 97.253 85.4682 97.2294 85.4446C97.2178 85.429 97.2021 85.4133 97.1903 85.3976C97.1667 85.3702 97.1393 85.3428 97.1119 85.3153C97.1001 85.3035 97.0923 85.2917 97.0805 85.284C97.0452 85.2486 97.006 85.2095 96.9668 85.1741C96.9589 85.1702 96.9551 85.1624 96.9473 85.1584C96.9158 85.1271 96.8806 85.0996 96.8453 85.0723C96.8335 85.0644 96.8217 85.0526 96.81 85.0448C96.7747 85.0135 96.7355 84.986 96.7002 84.9585C96.6963 84.9546 96.6884 84.9506 96.6845 84.9467C96.6414 84.9154 96.5983 84.8879 96.5551 84.8605C96.5433 84.8527 96.5277 84.8448 96.516 84.837C96.4963 84.8252 96.4729 84.8096 96.4532 84.7978C96.4415 84.7939 96.4336 84.786 96.4218 84.7782C96.4061 84.7703 96.3905 84.7585 96.3709 84.7507C96.3434 84.7351 96.3121 84.7194 96.2846 84.7076C96.2651 84.6958 96.2415 84.688 96.2219 84.6762C96.1983 84.6645 96.1788 84.6567 96.1552 84.6488C96.1239 84.6331 96.0886 84.6213 96.0573 84.6095C96.0259 84.5979 95.9984 84.59 95.9671 84.5782C95.9514 84.5743 95.9357 84.5665 95.9239 84.5625C95.8769 84.5468 95.8299 84.5352 95.7827 84.5273C95.4025 84.4449 95.1006 84.5116 94.9124 84.6841C94.9006 84.6919 94.8928 84.7037 94.881 84.7155H94.8693Z",
    fill: "url(#paint105_linear_722_15901)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7076 86.2872C97.9624 87.087 97.5077 87.5888 96.6922 87.4123C95.8767 87.236 95.0102 86.4439 94.7593 85.6481C94.5044 84.8482 94.9593 84.3465 95.7748 84.5229C96.5902 84.6954 97.4567 85.4873 97.7076 86.2872Z",
    fill: "url(#paint106_linear_722_15901)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2766 81.5208L96.7709 80.5053L103.648 72.7542L104.836 73.0247L98.0411 80.4897L98.3627 81.2894L97.2766 81.5208Z",
    fill: "url(#paint107_linear_722_15901)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7709 80.5053L98.0411 80.4897L104.836 73.0247L103.648 72.7542L96.7709 80.5053Z",
    fill: "url(#paint108_linear_722_15901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_15901",
    x1: 77.0077,
    y1: 54.617,
    x2: 88.8091,
    y2: 70.9454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_722_15901",
    x1: 85.5633,
    y1: 57.1584,
    x2: 82.8205,
    y2: 59.3366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_722_15901",
    x1: 24.001,
    y1: 45.517,
    x2: 55.2469,
    y2: 42.5953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_722_15901",
    x1: 84.4088,
    y1: 29.6537,
    x2: 79.9975,
    y2: 20.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_722_15901",
    x1: 62.7686,
    y1: 53.8217,
    x2: 84.1885,
    y2: 53.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_722_15901",
    x1: 62.7686,
    y1: 53.674,
    x2: 84.1885,
    y2: 53.2323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_722_15901",
    x1: 99.3447,
    y1: 29.985,
    x2: 65.7156,
    y2: 29.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_722_15901",
    x1: 98.522,
    y1: 29.8157,
    x2: 66.6416,
    y2: 29.8157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BF9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_722_15901",
    x1: 93.3012,
    y1: 52.1666,
    x2: 47.9921,
    y2: 52.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_722_15901",
    x1: 70.7287,
    y1: 67.5981,
    x2: 70.6841,
    y2: 58.2033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_722_15901",
    x1: 58.6637,
    y1: 46.0114,
    x2: 88.3101,
    y2: 45.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_722_15901",
    x1: 70.5425,
    y1: 45.1713,
    x2: 72.1895,
    y2: 45.1418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_722_15901",
    x1: 69.0521,
    y1: 44.4399,
    x2: 70.7031,
    y2: 44.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_722_15901",
    x1: 67.5612,
    y1: 43.7101,
    x2: 69.2158,
    y2: 43.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_722_15901",
    x1: 66.5564,
    y1: 44.4423,
    x2: 68.2549,
    y2: 44.4119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_722_15901",
    x1: 64.105,
    y1: 44.4446,
    x2: 65.7645,
    y2: 44.4148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_722_15901",
    x1: 65.0772,
    y1: 43.7121,
    x2: 66.764,
    y2: 43.6818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_722_15901",
    x1: 75.0138,
    y1: 47.3602,
    x2: 76.6498,
    y2: 47.3309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_722_15901",
    x1: 76.5039,
    y1: 48.0895,
    x2: 78.1361,
    y2: 48.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_722_15901",
    x1: 77.9942,
    y1: 48.8193,
    x2: 79.6226,
    y2: 48.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_722_15901",
    x1: 72.0329,
    y1: 45.9011,
    x2: 73.6763,
    y2: 45.8716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_722_15901",
    x1: 73.523,
    y1: 46.6304,
    x2: 75.1627,
    y2: 46.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_722_15901",
    x1: 71.9867,
    y1: 49.593,
    x2: 73.6653,
    y2: 49.5628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_722_15901",
    x1: 73.4633,
    y1: 50.3309,
    x2: 75.1444,
    y2: 50.3007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_722_15901",
    x1: 74.9392,
    y1: 51.0682,
    x2: 76.623,
    y2: 51.0379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_722_15901",
    x1: 64.8047,
    y1: 42.3261,
    x2: 66.2449,
    y2: 42.3002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_722_15901",
    x1: 70.5105,
    y1: 48.8552,
    x2: 72.1864,
    y2: 48.8251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_722_15901",
    x1: 64.6048,
    y1: 45.906,
    x2: 66.2703,
    y2: 45.8761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_722_15901",
    x1: 76.416,
    y1: 51.8061,
    x2: 78.1023,
    y2: 51.7758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_722_15901",
    x1: 67.5574,
    y1: 47.3816,
    x2: 69.2282,
    y2: 47.3516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_722_15901",
    x1: 69.034,
    y1: 48.1194,
    x2: 70.7074,
    y2: 48.0895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_722_15901",
    x1: 65.5835,
    y1: 45.1795,
    x2: 67.2431,
    y2: 45.1497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_722_15901",
    x1: 70.9932,
    y1: 46.637,
    x2: 72.7262,
    y2: 46.6059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_722_15901",
    x1: 69.5138,
    y1: 45.9062,
    x2: 71.2353,
    y2: 45.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_722_15901",
    x1: 67.0629,
    y1: 45.9166,
    x2: 68.7224,
    y2: 45.8868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_722_15901",
    x1: 72.4718,
    y1: 47.3695,
    x2: 74.2163,
    y2: 47.3381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_722_15901",
    x1: 68.0353,
    y1: 45.1754,
    x2: 69.7451,
    y2: 45.1448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_722_15901",
    x1: 73.951,
    y1: 48.1003,
    x2: 75.7071,
    y2: 48.0687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_722_15901",
    x1: 67.0395,
    y1: 42.2967,
    x2: 68.6405,
    y2: 42.2679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_722_15901",
    x1: 68.5416,
    y1: 46.6533,
    x2: 70.2011,
    y2: 46.6235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_722_15901",
    x1: 75.4296,
    y1: 48.8312,
    x2: 77.1971,
    y2: 48.7994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_722_15901",
    x1: 76.9084,
    y1: 49.5641,
    x2: 78.6876,
    y2: 49.5322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_722_15901",
    x1: 75.936,
    y1: 50.3367,
    x2: 77.5956,
    y2: 50.3068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_722_15901",
    x1: 78.3871,
    y1: 50.2944,
    x2: 80.1778,
    y2: 50.2622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_722_15901",
    x1: 79.8663,
    y1: 51.0252,
    x2: 81.6685,
    y2: 50.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_722_15901",
    x1: 70.0204,
    y1: 47.3903,
    x2: 71.68,
    y2: 47.3606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_722_15901",
    x1: 77.4155,
    y1: 51.0738,
    x2: 79.0751,
    y2: 51.0441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_722_15901",
    x1: 80.9751,
    y1: 50.2801,
    x2: 82.5961,
    y2: 50.2509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_722_15901",
    x1: 71.4995,
    y1: 48.1275,
    x2: 73.1591,
    y2: 48.0977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_722_15901",
    x1: 72.9782,
    y1: 48.8647,
    x2: 74.6377,
    y2: 48.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_722_15901",
    x1: 79.4847,
    y1: 49.5507,
    x2: 81.1094,
    y2: 49.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_722_15901",
    x1: 74.4574,
    y1: 49.5996,
    x2: 76.1169,
    y2: 49.5697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_722_15901",
    x1: 66.0814,
    y1: 46.6438,
    x2: 67.7495,
    y2: 46.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_722_15901",
    x1: 72.1053,
    y1: 51.175,
    x2: 74.1502,
    y2: 51.1383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_722_15901",
    x1: 61.8154,
    y1: 45.992,
    x2: 63.8157,
    y2: 45.9561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_722_15901",
    x1: 75.0457,
    y1: 52.655,
    x2: 77.1034,
    y2: 52.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_722_15901",
    x1: 73.5754,
    y1: 51.9158,
    x2: 75.6269,
    y2: 51.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_722_15901",
    x1: 59.7429,
    y1: 54.3282,
    x2: 69.8452,
    y2: 54.1468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_722_15901",
    x1: 76.5155,
    y1: 53.3958,
    x2: 78.5797,
    y2: 53.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_722_15901",
    x1: 64.7551,
    y1: 47.4719,
    x2: 66.7684,
    y2: 47.4358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_722_15901",
    x1: 63.2856,
    y1: 46.7311,
    x2: 65.2925,
    y2: 46.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_722_15901",
    x1: 66.2386,
    y1: 48.9517,
    x2: 72.646,
    y2: 48.8367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_722_15901",
    x1: 65.8249,
    y1: 41.7733,
    x2: 67.1187,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_722_15901",
    x1: 83.9553,
    y1: 51.7335,
    x2: 85.5225,
    y2: 51.7054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_722_15901",
    x1: 84.8761,
    y1: 50.9053,
    x2: 86.1173,
    y2: 50.8831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_722_15901",
    x1: 60.942,
    y1: 45.378,
    x2: 62.3419,
    y2: 45.3528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_722_15901",
    x1: 79.454,
    y1: 54.8053,
    x2: 81.5651,
    y2: 54.7675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_722_15901",
    x1: 79.3684,
    y1: 53.2796,
    x2: 81.06,
    y2: 53.2492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_722_15901",
    x1: 82.8235,
    y1: 52.4865,
    x2: 84.6207,
    y2: 52.4542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_722_15901",
    x1: 80.8445,
    y1: 54.022,
    x2: 82.5528,
    y2: 53.9913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_722_15901",
    x1: 77.9853,
    y1: 54.135,
    x2: 80.056,
    y2: 54.0978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_722_15901",
    x1: 62.8007,
    y1: 43.7683,
    x2: 64.2865,
    y2: 43.7417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_722_15901",
    x1: 80.4172,
    y1: 48.7562,
    x2: 82.2826,
    y2: 48.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_722_15901",
    x1: 81.9041,
    y1: 49.4744,
    x2: 83.799,
    y2: 49.4403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_722_15901",
    x1: 78.9309,
    y1: 48.0397,
    x2: 80.767,
    y2: 48.0067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_722_15901",
    x1: 83.39,
    y1: 50.1908,
    x2: 85.3143,
    y2: 50.1563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_722_15901",
    x1: 77.4441,
    y1: 47.321,
    x2: 79.2508,
    y2: 47.2886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_722_15901",
    x1: 82.465,
    y1: 51.0099,
    x2: 84.0823,
    y2: 50.9808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_722_15901",
    x1: 78.8942,
    y1: 51.811,
    x2: 80.5538,
    y2: 51.7811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_722_15901",
    x1: 75.9579,
    y1: 46.6045,
    x2: 77.7352,
    y2: 46.5726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_722_15901",
    x1: 80.3776,
    y1: 52.7915,
    x2: 83.4972,
    y2: 52.7355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_722_15901",
    x1: 81.3448,
    y1: 51.7582,
    x2: 83.1586,
    y2: 51.7257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_722_15901",
    x1: 63.7971,
    y1: 43.0487,
    x2: 65.2755,
    y2: 43.0221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_722_15901",
    x1: 77.8923,
    y1: 52.5439,
    x2: 79.5812,
    y2: 52.5136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_722_15901",
    x1: 63.1288,
    y1: 45.168,
    x2: 64.7916,
    y2: 45.1381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_722_15901",
    x1: 61.8038,
    y1: 44.4843,
    x2: 63.3138,
    y2: 44.4572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_722_15901",
    x1: 66.0716,
    y1: 42.9808,
    x2: 67.7301,
    y2: 42.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_722_15901",
    x1: 72.9855,
    y1: 45.1693,
    x2: 74.7041,
    y2: 45.1385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_722_15901",
    x1: 74.4718,
    y1: 45.8858,
    x2: 76.2198,
    y2: 45.8544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_722_15901",
    x1: 71.4988,
    y1: 44.4507,
    x2: 73.1879,
    y2: 44.4203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_722_15901",
    x1: 68.5255,
    y1: 43.0154,
    x2: 70.1559,
    y2: 42.9861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_722_15901",
    x1: 70.0122,
    y1: 43.7341,
    x2: 71.672,
    y2: 43.7044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_722_15901",
    x1: 77.7175,
    y1: 35.1347,
    x2: 68.3702,
    y2: 18.8821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_722_15901",
    x1: 57.464,
    y1: 29.983,
    x2: 89.1656,
    y2: 29.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_722_15901",
    x1: 58.452,
    y1: 29.9823,
    x2: 88.1773,
    y2: 29.9823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_722_15901",
    x1: 65.221,
    y1: 23.5544,
    x2: 68.8272,
    y2: 23.5544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38C49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B38F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_722_15901",
    x1: 64.0455,
    y1: 28.2589,
    x2: 67.6516,
    y2: 28.2589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38C49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B38F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_722_15901",
    x1: 62.868,
    y1: 33.3568,
    x2: 66.4742,
    y2: 33.3568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38C49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B38F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_722_15901",
    x1: 88.557,
    y1: 37.5995,
    x2: 105.319,
    y2: 37.5995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71E0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38C49E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_722_15901",
    x1: 87.3808,
    y1: 37.9906,
    x2: 104.143,
    y2: 37.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38C49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B38F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_722_15901",
    x1: 111.832,
    y1: 65.5214,
    x2: 114.271,
    y2: 67.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_722_15901",
    x1: 112.652,
    y1: 73.3331,
    x2: 104.696,
    y2: 70.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_722_15901",
    x1: 105.643,
    y1: 74.4634,
    x2: 104.967,
    y2: 77.5451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_722_15901",
    x1: 106.261,
    y1: 80.355,
    x2: 98.3047,
    y2: 78.0191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_722_15901",
    x1: 99.2514,
    y1: 81.4829,
    x2: 98.5759,
    y2: 84.5647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_722_15901",
    x1: 99.9612,
    y1: 85.0904,
    x2: 95.1727,
    y2: 83.6845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_722_15901",
    x1: 96.5146,
    y1: 84.682,
    x2: 95.9522,
    y2: 87.2481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_722_15901",
    x1: 101.777,
    y1: 72.3475,
    x2: 99.6506,
    y2: 82.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_722_15901",
    x1: 97.71,
    y1: 80.0725,
    x2: 102.684,
    y2: 74.6097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeActionResponse);
export default __webpack_public_path__ + "static/media/OfficeActionResponse.be1c3c1a385904c4208ac2d6c123c270.svg";
export { ForwardRef as ReactComponent };